import useSWR from 'swr';
import fetcher from './fetcher';

function useSupplierGroup(groupId, hasInvoices = false) {
  const { data, error, isLoading } = useSWR(
    `/supplier_groups/${groupId}.json?has_invoices=${hasInvoices}`,
    fetcher
  );

  return {
    group: data,
    isLoading,
    isError: error
  };
}

export default useSupplierGroup;
